export default __webpack_public_path__ + "static/media/pet-icon.3149be0f.svg";